import { interactionInitialState } from '@tmapy/config';
const initialState = {
    layers: [],
    view: {
        zoom: 0,
        minZoom: 0,
        maxZoom: 0,
        rotation: 0,
        resolution: 0,
        projection: 'EPSG:3857',
    },
    interaction: { ...interactionInitialState },
    zoomLevelShortcuts: null,
};
export const getInitialState = () => initialState;
//# sourceMappingURL=initialState.js.map